// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { brokeredPreviewStorage } from './previewAuthStorage';

const SUPABASE_URL = "https://mdinvjdjngskgpiqeaox.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1kaW52amRqbmdza2dwaXFlYW94Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTE0NDU2NzcsImV4cCI6MjA2NzAyMTY3N30.EMvXNZDnRQ5wfEzuHV-49mHmJKu4DmTKDV9bfokaK2A";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: brokeredPreviewStorage(),
    persistSession: true,
    autoRefreshToken: true,
  }
});